import { useState } from "react";
import { IdleTimerProvider } from "react-idle-timer";
import InactivityModal from "./modals/InactivityModal";
import { useData } from "../providers/DataProvider";

const timeout = 300_000;
const promptBeforeIdle = 9_000;

const Inactivity = () => {
  const { setToken, setCustomer, isKiosk } = useData();

  const [open, setOpen] = useState(false);

  const onClose = () => {
    setOpen((prevState) => !prevState);
  };
  const onPrompt = () => {
    setOpen(true);
  };
  const onIdle = () => {
    setToken(null);
    setCustomer(null);
    setOpen(false);
    location.replace(`https://${process.env.REACT_APP_SHOP_URL}/account/logout`);
  };
  const onActive = () => {
    setOpen(false);
  };

  if (!isKiosk) {
    return null;
  }

  return (
    <IdleTimerProvider
      timeout={timeout}
      promptBeforeIdle={promptBeforeIdle}
      throttle={500}
      onPrompt={onPrompt}
      onIdle={onIdle}
      onActive={onActive}
      events={["touchcancel", "touchend", "touchmove", "touchstart"]}
    >
      <InactivityModal open={open} onClose={onClose} />
    </IdleTimerProvider>
  );
};

export default Inactivity;
